import { render, staticRenderFns } from "./modalEmail.vue?vue&type=template&id=e8dd7fd6&scoped=true"
import script from "./modalEmail.vue?vue&type=script&lang=js"
export * from "./modalEmail.vue?vue&type=script&lang=js"
import style0 from "./modalEmail.vue?vue&type=style&index=0&id=e8dd7fd6&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8dd7fd6",
  null
  
)

export default component.exports